import React from 'react';
import {FeaturesIconEnum} from '../icons/features/featuresIcon.types';
import styled from 'styled-components';
import {FeaturesIcon} from '../icons/features/FeaturesIcon';
import {VerticalSpacer} from '../spacer';
import {Typography as Text} from '../typography';
import {Button, CmsButtonProps} from '../buttons';
import {Hyperlink} from '../links';
import {AccentColorOptions} from 'epic-ue-theme';

const Styled = styled.div`
    .logo-wrap {
        height: 80px;
        width: 80px;
    }

    ul {
        margin: 0;
        padding-left: 26px;
        li .paragraph {
            color: ${(p) => p.theme.palette.text.primary};
            margin-left: 9px;
        }
    }

    .view-all {
        padding: 0;
        text-align: left;
        display: inline-block;
        .underline {
            display: inline-flex;
        }
    }

    .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }
`;

export interface FeaturesGridCardProps {
    icon?: FeaturesIconEnum;
    title?: string;
    description?: string;
    bullets?: string[];
    viewAll?: CmsButtonProps;
    links?: CmsButtonProps[];
    accentColor?: AccentColorOptions;
    featuresIconAccentColor?: AccentColorOptions;
}

export const FeaturesGridCard = ({
    icon,
    title,
    description,
    bullets = [],
    viewAll = {},
    links = [],
    accentColor = 'sky',
    featuresIconAccentColor = 'forest'
}: FeaturesGridCardProps): JSX.Element => {
    return (
        <Styled>
            {icon ? (
                icon === 'line' ? (
                    <>
                        <FeaturesIcon variant={icon} accentColor={featuresIconAccentColor} />
                        <VerticalSpacer variant="custom" spacing={5} />
                    </>
                ) : (
                    <>
                        <div className="logo-wrap">
                            <FeaturesIcon variant={icon} accentColor={featuresIconAccentColor} />
                        </div>
                        <VerticalSpacer variant="custom" spacing={4} />
                    </>
                )
            ) : (
                ''
            )}

            {title ? (
                <>
                    <Text variant="h2">{title}</Text>
                    <VerticalSpacer variant="custom" spacing={2} />
                </>
            ) : (
                ''
            )}

            {description ? <Text variant="p">{description}</Text> : ''}

            {bullets && bullets.length ? (
                <>
                    <VerticalSpacer variant="custom" spacing={2} />
                    <ul>
                        {bullets.map((bullet, i) => (
                            <li key={`${title}-bullet-${i}`}>
                                <Text variant="p">{bullet}</Text>
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                ''
            )}

            {viewAll && viewAll.label && viewAll.href ? (
                <>
                    <VerticalSpacer variant="heading" />
                    <Button
                        className="view-all"
                        type="tertiary"
                        href={viewAll.href}
                        big={false}
                        color={accentColor}>
                        {viewAll.label}
                    </Button>
                </>
            ) : (
                ''
            )}

            {links && links.length ? (
                <>
                    <VerticalSpacer variant="heading" />
                    {links.map((link, index) => (
                        <Text key={link.href}>
                            <Hyperlink accentColor={accentColor} href={link.href}>
                                {link.label}
                            </Hyperlink>
                            {index < links.length - 1 ? <VerticalSpacer variant="paragraph" /> : ''}
                        </Text>
                    ))}
                </>
            ) : (
                ''
            )}
        </Styled>
    );
};
